import { render } from "./Instalador.vue?vue&type=template&id=ca3de2b6"
import script from "./Instalador.vue?vue&type=script&lang=js"
export * from "./Instalador.vue?vue&type=script&lang=js"

import "./Instalador.vue?vue&type=style&index=0&id=ca3de2b6&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__